"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = require("prop-types");
var _constant = require("../Theme/constant");
var _sectionTile = _interopRequireDefault(require("../SectionTile/sectionTile.proptypes"));
var _constant2 = require("./constant");
var _default = {
  PropTypes: {
    data: (0, _propTypes.arrayOf)((0, _propTypes.shape)(_sectionTile.default.PropTypes)).isRequired,
    title: _propTypes.string,
    titleColor: (0, _propTypes.oneOf)(_constant.ARR_COLORS),
    titleAlign: (0, _propTypes.oneOf)(Object.values(_constant2.TITLE_ALIGN)),
    defaultSelectedData: _propTypes.any,
    onClick: _propTypes.func,
    theme: _propTypes.string,
    accessible: _propTypes.bool,
    customProperties: _propTypes.object,
    numOfCol: _propTypes.string,
    alignCenter: _propTypes.bool,
    minHeight: _propTypes.string,
    defaultBorderColor: _propTypes.string,
    isMultipleChoiceAllowed: _propTypes.bool,
    multipleSelectedData: _propTypes.array,
    enableHover: _propTypes.bool,
    fireGtm: _propTypes.func,
    setActionName: _propTypes.func
  },
  DefaultProps: {
    titleColor: _constant2.TILE_GROUP_DEFAULTS.TITLE_COLOR,
    titleAlign: _constant2.TILE_GROUP_DEFAULTS.TITLE_ALIGN,
    theme: _constant.DEFAULT_THEME,
    accessible: true,
    isMultipleChoiceAllowed: false,
    numOfCol: '4',
    alignCenter: false,
    enableHover: true,
    multipleSelectedData: []
  }
};
exports.default = _default;